const Colors = {
	// Brand
	primary: '#CA0216',
	green: '#236666',
	green600: '#346566',
	green700: '#015C68',
	green900: '#002D33',
	success: '#4CD964',
	gold: '#B49759',
	goldLight: '#C9B075',
	goldSoft: '#D9D0AA',
	goldPale: '#E9E2CC',
	blue: '#3B82F6',

	// Neutrals
	white: '#FFFFFF',
	black: '#000000',

	// Greys, light to dark
	gray50: '#F7F7F7',
	gray75: '#F5F5F5',
	gray80: '#F3F3F3',
	gray100: '#F0F0F0',
	gray150: '#EEEEEE',
	gray175: '#E9E9EB',
	gray200: '#E8E8E8',
	gray300: '#DDDDDD',
	gray350: '#CACACA',
	gray400: '#AAAAAA',
	gray450: '#999999',
	gray500: '#979797',
	gray550: '#868583',
	gray600: '#777777',
	gray650: '#717171',
	gray700: '#555555',
	gray750: '#4A4A4A',
	gray800: '#414140',
	gray850: '#252525',
	gray900: '#222222',
	gray950: '#171717',

	// Warm beige page background, deliberately not part of the grey ramp.
	sand: '#ECEAE5',

	greenGray: '#4A5452',

	// Alpha variants, suffix is the hex alpha
	black1A: '#0000001A',
	black66: '#00000066',
	black77: '#00000077',
	black80: '#00000080',
	black99: '#00000099',
	blackA3: '#000000A3',
	blackCC: '#000000CC',
	blackD9: '#000000D9',
	white00: '#FFFFFF00',
	white33: '#FFFFFF33',
	white4D: '#FFFFFF4D',
	white66: '#FFFFFF66',
	whiteCC: '#FFFFFFCC',
	whiteE6: '#FFFFFFE6',

	// Single-purpose colours
	headerButton: '#E4E9E9',
	headerButtonPressed: '#CDD1D1',
	headerButtonOnImage: '#00121599',
	headerButtonOnImagePressed: '#001215CC',
	successToastBorder: '#008000',
	calendarDisabledOverlay: '#4141404D',
	inspirationCardOverlay: '#4A4A4A33',
	inputOutline: '#49454F',

	transparent: 'transparent',
};

export default Colors;
